import React, { useEffect, useRef, useState } from "react";
import styles from "./Attendees.module.css";
import { DropDown, SubmitButton, TextComponent } from "../../../components";
import { Col, List, Skeleton } from "antd";
import { BsFillCheckCircleFill } from "react-icons/bs";
import Modal from "../../../components/modal/Modal";

import { useLocation, useNavigate } from "react-router-dom";
import RsvpModal from "../../../components/rsvpModal/RsvpModal";
import { EventPlanningMiddleware } from "../../../Store/Middlewares/EventPlanningMiddleware";
import { useDispatch, useSelector } from "react-redux";

const familyList = [
  {
    id: 1,
    name: "Frances Swann",
    attendanceStatus: "Confirmed",
    table: "head Table 2",
  },
  {
    id: 2,
    name: "Alex Buckmaster",
    attendanceStatus: "Confirmed",
    table: "head Table 2",
  },
  {
    id: 3,
    name: "Joshua Jones",
    attendanceStatus: "Pending",
    table: "head Table 2",
  },
  {
    id: 4,
    name: "Lorri Warf",
    attendanceStatus: "Not Attending",
    table: "head Table 2",
  },
  {
    id: 4,
    name: "Lorri Warf",
    attendanceStatus: "Not Attending",
    table: "head Table 2",
  },
  {
    id: 4,
    name: "Lorri Warf",
    attendanceStatus: "Not Attending",
    table: "head Table 2",
  },
  {
    id: 4,
    name: "Lorri Warf",
    attendanceStatus: "Not Attending",
    table: "head Table 2",
  },
  {
    id: 4,
    name: "Lorri Warf",
    attendanceStatus: "Not Attending",
    table: "head Table 2",
  },
];

const RenderList = ({ item }) => {
  const navigate = useNavigate();
  return (
    <div
      // key={item?.id}
      className={styles.listItem}
      onClick={() =>
        navigate("/events/attendee", {
          state: { headrTitle: "Attendee", item },
        })
      }
    >
      <div className={styles.leftItem}>
        <TextComponent text={item?.name} textClass={styles.listTxt} />
      </div>
      <div
        className={styles.midItem}
        style={{
          color: item?.status == "confirmed" ? "var(--primary-color)" : "black",
        }}
      >
        <TextComponent
          style={{
            fontWeight: item?.status == "Not Attending" ? "400" : "600",
          }}
          text={item?.status}
          textClass={styles.listTxt}
        />
      </div>
      <div className={styles.midItem}>
        <TextComponent text={item?.table_name} textClass={styles.listTxt} />
      </div>
      <div className={styles.rightItem}>
        <BsFillCheckCircleFill
          color={
            item?.status == "confirmed"
              ? "var(--primary-color)"
              : item?.status == "Not Attending"
              ? "red"
              : "black"
          }
        />
      </div>
    </div>
  );
};

const renderFamilyList = (item, index) => {
  console.log("item", item);
  return (
    <div key={item?.id}>
      <TextComponent text={item?.name} textClass={styles.textHeading} />
      <div className={styles.headingItem}>
        <div className={styles.leftItem}>
          <TextComponent text={"Guest Name"} textClass={styles.listTxt} />
        </div>
        <div className={styles.midItem}>
          <TextComponent text={"Attendance"} textClass={styles.listTxt} />
        </div>
        <div className={styles.midItem}>
          <TextComponent text={"Table"} textClass={styles.listTxt} />
        </div>
        <div className={styles.rightItem}>
          {/* <BsFillCheckCircleFill /> */}
        </div>
      </div>
      <List
        className={styles.list}
        // grid={{ gutter:16}}
        // itemLayout="horizontal"
        dataSource={item?.data}
        renderItem={(item) => <RenderList item={item} key={item.id} />}
      />
    </div>
  );
};

const Attendees = () => {
  const [attendeesStatus, setAttendeesStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [rsvpModal, setrsvpModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Attendees = useSelector((state) => state.EventPlanningReducer.Attendee);
  const AttendeeDetail = useSelector(
    (state) => state.EventPlanningReducer.AttendeeDetail
  );

  const handleAttendeesStatus = (value) => {
    setAttendeesStatus(value == "All" ? "" : value);
  };

  const { state } = useLocation();

  const eventDetails = state?.eventData;

  // useEffect(() => {
  //   dispatch(
  //     EventPlanningMiddleware.eventAttendees({
  //       id: eventDetails?.id,
  //       name: "",
  //       status: "",
  //     })
  //   );
  // }, []);

  useEffect(() => {
    setLoading(true);
    dispatch(
      EventPlanningMiddleware.eventAttendees({
        id: eventDetails?.id,
        name: "",
        status: attendeesStatus.toLowerCase(),
      })
    )
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, [attendeesStatus]);

  // const onSearch = (val) => {
  //   setsearch(val);
  //   clearTimeout(timeout.current);
  //   timeout.current = setTimeout(() => {
  //     setLoading(true);
  //     dispatch(
  //       EventPlanningMiddleware.eventAttendees({
  //         id: EventDetails?.id,
  //         name: val,
  //         status: filterby.toLowerCase(),
  //       })
  //     )
  //       .then(() => setLoading(false))
  //       .catch(() => setLoading(false));
  //   }, 1500);
  // };

  return (
    <div className={styles.mainCon}>
      <div className={styles.header}>
        <Col className={styles.dropdownDiv}>
          <DropDown
            placeholder={"All"}
            stylesClass={styles.dropdown}
            name={"All"}
            onChange={handleAttendeesStatus}
            options={[
              { value: "", option: "All" },
              { value: "confirmed", option: "Confirmed" },
              { value: "pending", option: "Pending" },
              { value: "not attending", option: "Not Attending" },
            ]}
          />
        </Col>
        <SubmitButton
          btnClass={styles.headerBtn}
          outline
          title={"Request RSVP"}
          onClick={() => setrsvpModal(true)}
        />
      </div>
      <Skeleton loading={loading}>
        <List
          className={styles.listAtendees}
          // grid={{ gutter:16}}
          // itemLayout="horizontal"
          dataSource={Attendees}
          renderItem={renderFamilyList}
        />
      </Skeleton>
      <RsvpModal rsvpModal={rsvpModal} setrsvpModal={setrsvpModal} eventData={eventDetails} />
    </div>
  );
};

export default Attendees;
